import { auth, posts } from './apiUrl';
import axios from 'axios';
import { request } from '../../../service/common';

//게시글 목록 조회
export const getPosts = async ({ category, dateFrom, dateTo }) => {
  const { data } = await request.get(posts.list, {
    params: { category, dateFrom, dateTo },
  });
  return data.datas;
};

//게시글 등록
export const postPosts = async ({ memberId, title, content, category }) => {
  const { data } = await request.post(posts.submit, { memberId, title, content, category });
  return data;
};

//전체 게시글 생성 년/월 조회
export const getPostsYearMonth = async () => {
  const { data } = await request.get(posts.yearMonth);
  return data.datas;
};

//게시글 삭제
export const deletePost = async ({ postId }) => {
  const { data } = await request.delete(posts.delete(postId));
  return data.datas;
};

//게시글 댓글 조회
export const getPostsComments = async ({ postId }) => {
  const { data } = await request.get(posts.comment(postId));
  return data.datas;
};

//게시글 댓글 등록
export const addPostsComments = async ({ postId, memberId, comment }) => {
  const { data } = await request.post(posts.comment(postId), { memberId, comment });
  return data;
};

//게시글 댓글 삭제
export const deletePostsComments = async ({ commentId }) => {
  const { data } = await request.delete(posts.deleteComment(commentId));
  return data;
};
